import { render, staticRenderFns } from "./ModalIregInactiveAction.vue?vue&type=template&id=084ed22c&scoped=true&"
import script from "./ModalIregInactiveAction.vue?vue&type=script&lang=js&"
export * from "./ModalIregInactiveAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084ed22c",
  null
  
)

export default component.exports